import React from "react";

const SubLedgerBalance = () => {

  return <div>SubLedgerBalance</div>;
};

export default SubLedgerBalance;
